import React, { Component } from "react";
import { fire, auth } from "../../../firebase/index";
import LocalizedStrings from "react-localization";

let localizationStrings = new LocalizedStrings({
  en: {
    reply1:
      "The quality and reliability of eGeeTouch® smart luggage lock is subjected to and survived over repeated drop tests over a height of 1.5 meters at various fall angles and floor materials. Sustained tests for jerk, tumbling, temperature swing and water resistance are performed in factory according to ISO9001 and ISO14001 standards. Our smartlocks pass FCC and CE conducted by TUV SUD, a world-leading 3rd party accredited independent test provider. It is also TSA-approved and fulfil IATA requirements. For more info on Tests & Certifications, ",
    reply2: "click here",
    back: "Back",
  },
  ja: {
    reply1:
      "eGeeTouch® スマート ラゲッジ ロックの品質と信頼性は、さまざまな落下角度と床材で 1.5 メートルの高さからの繰り返しの落下テストを受け、耐えられています。 ISO9001およびISO14001規格に従って、ジャーク、タンブリング、温度スイング、耐水性の持続テストが工場で実行されます。当社のスマートロックは、世界をリードする第三者認定の独立テストプロバイダーである TUV SUD によって実施された FCC および CE に合格しています。 TSA の承認も受けており、IATA の要件も満たしています。テストと認定の詳細については、",
    reply2: "ここをクリック",
    back: "戻る",
  },
  es: {
    reply1:
      "La calidad y confiabilidad del candado de equipaje inteligente eGeeTouch® se somete y sobrevive a repetidas pruebas de caída desde una altura de 1,5 metros en diversos ángulos de caída y materiales del piso. En fábrica se realizan pruebas sostenidas de sacudidas, caídas, cambios de temperatura y resistencia al agua de acuerdo con las normas ISO9001 e ISO14001. Nuestras candados inteligentes pasan la FCC y la CE realizadas por TUV SUD, un proveedor de pruebas independiente acreditado por terceros líder en el mundo. También está aprobado por la TSA y cumple con los requisitos de la IATA. Para obtener más información sobre pruebas y certificaciones, ",
    reply2: "haga clic aquí",
    back: "Atrás",
  },
});

class Q15_component extends Component {
  constructor(props) {
    super(props);

    this.state = {
      triggerValue: "0",
      clicked: false,
      language: "en",
    };
  }

  componentDidMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          localizationStrings.setLanguage(snapshot.val());
          this.setState({ language: snapshot.val() });
        });
    }
  }

  handleButtonClick2 = () => {
    if (!this.state.clicked) {
      this.setState({ triggerValue: "cancel", clicked: true }, () => {
        this.props.triggerNextStep({
          value: "cancel",
          trigger: "cancel",
        });
      });
    }
  };

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    const buttonStyle = {
      marginTop: "10px",
      width: "215px",
      backgroundColor: "#FFC500",
      color: "black",
      borderRadius: "25px",
      textAlign: "center",
      padding: "10px 10px",
      cursor: "pointer",
      transition: "background-color 0.3s",
      border: "none",
    };

    const buttonHoverStyle = {
      color: "white",
      backgroundColor: "#EF6C00",
    };

    const { triggerValue, clicked } = this.state;

    return (
      <div>
        {localizationStrings.reply1}
        <a
          href="http://www.egeetouch.com/support/certificates"
          target="_blank"
          style={{ textDecoration: "underline", color: "black" }}
        >
          {localizationStrings.reply2}
        </a>
        {this.state.language === "ja" ? "。" : "."}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            margin: "12px 0",
          }}
        >
          <button
            style={{
              ...buttonStyle,
              ...(triggerValue === "cancel" && buttonHoverStyle),
            }}
            onMouseEnter={() => this.setState({ isButtonHovered: true })}
            onMouseLeave={() => this.setState({ isButtonHovered: false })}
            onClick={this.handleButtonClick2}
            disabled={clicked}
          >
            {localizationStrings.back}
          </button>
        </div>
      </div>
    );
  }
}

export default Q15_component;
